package co.maytes.standupbot.dashboard.features.roster

import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.slack.ChannelMemberDto
import co.maytes.standupbot.shared.roster.LinearMatch

sealed interface RosterPickerState {
    data object NoChannel : RosterPickerState

    data object Loading : RosterPickerState

    data class Ready(
        val members: List<ChannelMemberDto>,
        val truncated: Boolean,
        val botIsMember: Boolean,
    ) : RosterPickerState

    data object BotNotInChannel : RosterPickerState

    data object SlackNotConnected : RosterPickerState

    data class SlackDidNotAnswer(val detail: String?) : RosterPickerState

    data class Failed(val message: String) : RosterPickerState
}

sealed interface LinearPreview {
    data object Hidden : LinearPreview

    data object Loading : LinearPreview

    data object NotConnected : LinearPreview

    data object Unavailable : LinearPreview

    data class Ready(val matches: Map<String, LinearMatch>) : LinearPreview
}

private const val BAD_GATEWAY = 502

fun ApiError.toRosterState(): RosterPickerState =
    when {
        this is ApiError.Http && code == "bot-not-in-channel" -> RosterPickerState.BotNotInChannel
        this is ApiError.Http && code == "slack-not-connected" -> RosterPickerState.SlackNotConnected
        this is ApiError.Http && (status == BAD_GATEWAY || code == "slack-unavailable") ->
            RosterPickerState.SlackDidNotAnswer(detail)
        else -> RosterPickerState.Failed(displayMessage)
    }
